import React from 'react'
import { Box, Flex, Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import NoPayment from '../NoPayment'
const CurrencyWrapperLarge = ({ children }) =>
    <Copy as='span' padding='0' fontSize='small'>
        {children}
    </Copy>

CurrencyWrapperLarge.propTypes = {
    children: PropTypes.node,
}

const PriceDetails = ({booking}) => {
    const { priceDetails, displayPrice, displayDepositAmount } = booking
    return <Box>
        <Flex justifyContent='space-between'>
            <Copy padding='0' fontColor='darkGray' fontSize='small' fontWeight='bold'>
                <FormattedMessage defaultMessage='Detalles del precio' />
            </Copy>
            <NoPayment label={<FormattedMessage defaultMessage='Pago en oficina'/>} />
        </Flex>
        <Box mt='1em'>
            {priceDetails && priceDetails
                    .sort(({ price: priceA }, { price: priceB }) => priceA < priceB ? 1 : -1)
                    .map(({ price, displayPrice, title, qtySelected }, index) => {
                        const fontColor = (price < 0) ? 'success_dark' : 'gray'
                        const fontSize = 'small'
                        const fontWeight = (price < 0) ? 'medium' : 'regular'
                        return <Box mt='0.5em' key={`concept_${index}`} w='100%'>
                            <Flex width='100%' justifyContent='space-between'>
                                <Copy padding='0' fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight}>
                                    {title}
                                    {(qtySelected && qtySelected > 1) && ` x ${qtySelected}`}
                                </Copy>
                                <Copy padding='0 0 0 1em' transform='uppercase' fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight}>
                                    {(price === 0)
                                        ? <FormattedMessage defaultMessage='Gratis' />
                                        : displayPrice
                                    }
                                </Copy>
                            </Flex>
                        </Box>
                    })
                }
        </Box>
        <Box mt='0.5em'>
            <Flex width='100%' justifyContent='space-between' alignItems='end'>
                <Copy padding='0' fontSize='small' fontWeight='bold'>
                    <FormattedMessage defaultMessage='Total' /> <Copy as='span' padding='0' fontSize='xxxSmall' fontWeight='regular'>
                        <FormattedMessage defaultMessage='(impuestos incluídos)' />
                    </Copy>
                </Copy>
                <Copy width='100%' textAlign='right' padding='0' fontSize='small' fontWeight='bold'>
                    {displayPrice ? <CurrencyWrapperLarge>{displayPrice}</CurrencyWrapperLarge> : <FormattedMessage defaultMessage='Gratis' />}
                </Copy>
            </Flex>
        </Box>
        {displayDepositAmount && <Box mt='0.5em'>
            <Copy padding='0px 10px 0px 0px' fontColor='gray' fontSize='xxxSmall' fontWeight='regular'>
                <FormattedMessage defaultMessage='*Como garantía, se le retendrá un depósito de {displayDepositAmount}' values={{
                        displayDepositAmount,
                    }}/>
            </Copy>
        </Box>}
    </Box>
}
PriceDetails.propTypes = {
    booking: PropTypes.object,
}

export default PriceDetails
